import type {UpdateIvIntentPayload} from '@chekin/api';
import type {IVStoreState} from '../../../store/useIVStore';

type SaveBiomatchComparisonSuccessParams = {
  livenessVideo: Blob | null | undefined;
  intentId: string | null | undefined;
  livenessResultData: IVStoreState['livenessResultData'];
  isIvFailed: boolean;
  uploadLivenessVideo: (recordingVideo: Blob) => Promise<string | undefined>;
  updateIvIntent: (payload: UpdateIvIntentPayload) => Promise<unknown>;
};

export const saveBiomatchComparisonSuccess = async ({
  livenessVideo,
  intentId,
  livenessResultData,
  isIvFailed,
  uploadLivenessVideo,
  updateIvIntent,
}: SaveBiomatchComparisonSuccessParams) => {
  const livenessVideoUrl = livenessVideo
    ? await uploadLivenessVideo(livenessVideo)
    : undefined;

  if (!intentId) return;

  if (!livenessResultData) {
    await updateIvIntent({id: intentId, biomatch_passed: true});
    return;
  }

  await updateIvIntent({
    id: intentId,
    biomatch_passed: true,
    liveness_data: {
      passed: livenessResultData.passed ?? false,
      completed_actions: livenessResultData.completedActions,
      video_url: livenessVideoUrl,
      performed_by: livenessResultData.performedBy,
    },
    is_iv_failed: isIvFailed,
  });
};
